import { render, staticRenderFns } from "./Sistema.vue?vue&type=template&id=48cc9e50&scoped=true&"
import script from "./Sistema.vue?vue&type=script&lang=js&"
export * from "./Sistema.vue?vue&type=script&lang=js&"
import style0 from "./Sistema.vue?vue&type=style&index=0&id=48cc9e50&scoped=true&lang=css&"
import style1 from "./Sistema.vue?vue&type=style&index=1&id=48cc9e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cc9e50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VApp,VBtn,VContainer,VIcon,VMain,VSpacer,VSystemBar})
